import { getParameters } from 'codesandbox/lib/api/define';
// TODO: this function should:
// 1. take a use-case param
// 2. try to fetch the schema.graphql from neo4j-graph-examples
// 3. use the schema when creating the codesandbox
export var graphqlCodeSandboxURL = function (neo4jUri, neo4jUser, neo4jPassword, schema) {
    var params = getParameters({
        files: {
            '.env': {
                isBinary: false,
                content: "\nNEO4J_URI=".concat(neo4jUri, "\nNEO4J_USER=").concat(neo4jUser, "\nNEO4J_PASSWORD=").concat(neo4jPassword),
            },
            'schema.graphql': {
                isBinary: false,
                content: schema,
            },
            'index.js': {
                isBinary: false,
                content: /* JavaScript */ "\nconst { Neo4jGraphQL } = require(\"@neo4j/graphql\");\nconst { ApolloServer } = require(\"apollo-server\");\nconst neo4j = require(\"neo4j-driver\");\nconst fs = require(\"fs\");\nconst dotenv = require(\"dotenv\");\nconst path = require(\"path\");\n\n// Load contents of .env as environment variables\ndotenv.config();\n\n// Load GraphQL type definitions from schema.graphql file\nconst typeDefs = fs\n\t.readFileSync(path.join(__dirname, \"schema.graphql\"))\n\t.toString(\"utf-8\");\n\n// Create executable GraphQL schema from GraphQL type definitions,\n// using @neo4j/graphql to autogenerate resolvers\nconst neoSchema = new Neo4jGraphQL({\n\ttypeDefs,\n\tdebug: true,\n});\n\n// Create Neo4j driver instance\nconst driver = neo4j.driver(\n\tprocess.env.NEO4J_URI,\n\tneo4j.auth.basic(process.env.NEO4J_USER, process.env.NEO4J_PASSWORD)\n);\n\n// Create ApolloServer instance that will serve GraphQL schema created above\n// Inject Neo4j driver instance into the context object, which will be passed\n//  into each (autogenerated) resolver\nconst server = new ApolloServer({\n\tcontext: { driver, driverConfig: { database: process.env.NEO4J_DATABASE } },\n\tschema: neoSchema.schema,\n\tintrospection: true,\n\tplayground: true,\n});\n\n// Start ApolloServer\nserver.listen().then(({ url }) => {\n\tconsole.log(\"GraphQL server ready\");\n});\n",
            },
            'package.json': {
                /** @ts-ignore */
                content: {
                    scripts: {
                        start: 'node index.js',
                    },
                    dependencies: {
                        '@neo4j/graphql': '^1.0.0-alpha.5',
                        'apollo-server': '^2.21.0',
                        'apollo-server-lambda': '^2.21.0',
                        dotenv: '^8.2.0',
                        graphql: '^15.5.0',
                        'neo4j-driver': '^4.2.3',
                    },
                },
            },
        },
    });
    var url = "https://codesandbox.io/api/v1/sandboxes/define?parameters=".concat(params);
    return url;
};
